require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-tags-golf-sponsorship.json") })
        }
      }, "path---es-articles-tags-golf-sponsorship");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-tags-golf-sponsorship!./.cache/json/es-articles-tags-golf-sponsorship.json
// module id = 2338
// module chunks = 231608221292675